































































































import Vue, { PropType } from "vue";
import InputText from "@/components/atoms/InputText.vue";
import draggable from "vuedraggable";
import SwipeDeletable from "@/components/util/SwipeDeletable.vue";
import { Mode, Plot, PlotGroups, SubPlot, UpdatePlotPayload, UpdateSubPlotPayload } from "@/lib/models/plot";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { InputText, draggable, SwipeDeletable },
  props: {
    novelId: String,
    plotId: String,
    plots: Object as PropType<Plot | SubPlot>,
  },
  data() {
    const { plotId, plots } = this;
    const { plotGroups } = plots;

    return {
      plotGroups,
      changed: false,
      maxDescriptionLength: 2500,
      isOverMaxCharacterLengthWithDescription: false,
      plotName: plotId ? (plots as SubPlot).name : null,
    };
  },
  computed: {
    mode() {
      const { plots } = this;
      return plots.mode;
    },
    isCustom() {
      const { mode } = this;
      return mode === Mode.custom;
    },
  },
  methods: {
    setChanged(b) {
      this.changed = b;
      this.setModified(b);
    },
    input() {
      this.setChanged(true);
    },
    inputItem(e) {
      this.setChanged(true);
    },
    customScroll(scrollOffsetX, scrollOffsetY, evt, touchEvt$1, el, b, c) {
      // 横方向のスクロールを防ぐ
      el.scrollLeft = 0;
      return "continue";
    },
    /** アイテムを末尾に追加 */
    addPlotItem(index) {
      const key = uuidv4();
      this.plotGroups[index].plots.push({
        key,
        text: "",
      });

      setTimeout(() => {
        const added = document.querySelector(`[data-textarea-key='${key}']`) as any;
        // not work on iOS safari
        added.focus();
      }, 1);
    },
    async save() {
      const { $store, $router, novelId, plotId, mode, plotName, plotGroups } = this;
      const { dispatch } = $store;

      // プロットのモード変更によって文字数超過が発生する可能性が有るのでバリデーションを行う
      for (let index = 0; index < plotGroups.length; index++) {
        const element = plotGroups[index];
        if (element.description.length > this.maxDescriptionLength) {
          this.isOverMaxCharacterLengthWithDescription = true;
          setTimeout(() => (this.isOverMaxCharacterLengthWithDescription = false), 2000);
          return;
        }
      }

      if (plotId && plotName) {
        const updateSubPlotPayload: UpdateSubPlotPayload = {
          novelId,
          plotId,
          name: plotName,
          plotGroups,
          mode,
        };
        dispatch("plotModule/updateSubPlot", updateSubPlotPayload);
      } else {
        const updatePlotPayload: UpdatePlotPayload = {
          novelId,
          plotGroups,
        };
        dispatch("plotModule/updatePlot", updatePlotPayload);
      }

      this.setChanged(false);

      if (plotId) {
        $router.push({ name: "plot", params: { novelId, plotId } });
      } else {
        $router.push({ name: "plot", params: { novelId } });
      }
    },
    async deleteItem({ key, index }) {
      const target = this.plotGroups[index].plots.findIndex((k) => k.key === key);
      const item = document.querySelector(`[data-key='${key}']`) as any;

      let height = 100;
      const intervalId = setInterval(() => {
        item.style.height = `${height}px`;
        height -= 4;

        if (height <= 0) {
          this.plotGroups[index].plots.splice(target, 1);
          clearInterval(intervalId);
        }
      }, 5);

      this.setChanged(true);
    },
    addPlotGroup() {
      const plot = {
        name: "自由入力",
        description: "説明文",
        plots: [],
      };
      this.plotGroups.push(plot);
      this.setChanged(true);
    },
    emit() {
      this.$emit("input");
    },
    deletePlotGroup(index) {
      this.plotGroups.splice(index, 1);
      this.setChanged(true);
    },
  },
  watch: {
    plots: {
      handler(plots) {
        this.plotGroups = plots.plotGroups;
      },
      deep: true,
    },
  },
});

interface Props {
  novelId: string;
  plotId?: string;
  plots: Plot | SubPlot;
}

interface Data {
  plotGroups: PlotGroups[];
  changed: boolean;
  maxDescriptionLength: number;
  isOverMaxCharacterLengthWithDescription: boolean;
  plotName: string | null;
}

interface Computed {
  mode: Mode;
  isCustom: boolean;
}

interface Methods {
  setChanged(b: boolean): void;
  input(): void;
  inputItem(e: any): void;
  customScroll(scrollOffsetX: any, scrollOffsetY: any, evt: any, touchEvt$1: any, el: any, b: any, c: any): void;
  addPlotItem(index: number): void;
  save(): void;
  deleteItem({ key, index }: any): void;
  addPlotGroup(): void;
  emit(): void;
  deletePlotGroup(index: number): void;
}
